// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1mqtF","container":"styles_container__1WmPX","info":"styles_info__3HGDM","status":"styles_status__2ff83","title":"styles_title__24ktb"};